import InfoOutlined from '@material-ui/icons/InfoOutlined'
import { JIRA_SUPPORT_TICKET_LINK } from 'constants/links'
import { orgSelectors } from 'ducks/orgs'
import { styled, Tooltip } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useTranslateParse from 'util/useTranslateParse'

const StyledInfoIcon = styled(InfoOutlined)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.grey[700],
}))

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
})

type PropTypes = {
  label: string
}

const CreditCardCapTooltip: React.FC<PropTypes> = ({ label }) => {
  const translate = useTranslate()
  const translateParse = useTranslateParse()
  const currencySymbol = useSelector(orgSelectors.getCurrencySymbolFromOrg)
  const orgCountry = useSelector(orgSelectors.getOrgIso2)

  const capAmount = useMemo(() => {
    if (orgCountry === 'AU') {
      return `${currencySymbol}10,000`
    } else {
      return `${currencySymbol}6,000`
    }
  }, [orgCountry])

  const tooltipText = translateParse(
    'Customers can use cards to pay for amounts under %{capAmount}. Customers making payments over %{capAmount} will be automatically presented with an account to account payment method. If you need to enable card payments more than %{capAmount}, you can request a higher limit by clicking  <a>here<a>.',
    {
      a: (link: string) => (
        <a href={JIRA_SUPPORT_TICKET_LINK} target="_blank" rel="noreferrer">
          {link}
        </a>
      ),
    },
    { capAmount }
  )

  return (
    <Row>
      {translate(label)}
      <Tooltip title={tooltipText} interactive={true}>
        <StyledInfoIcon />
      </Tooltip>
    </Row>
  )
}
export default CreditCardCapTooltip
